import { CertifiedPublisherPropsMicrocopy } from '../../molecules/CertifiedPublisher/CertifiedPublisher.types';
import { QuantitySelectorPropsMicrocopy } from '../../molecules/QuantitySelector';
import {
  ReviewStarsPropsData,
  ReviewStarsPropsMicrocopy,
} from '../../molecules/ReviewStars/ReviewStars.types';

export const ProductInfoBadgeOptions = {
  Upm: 'upm',
  VerifiedSolutions: 'verifiedSolutions',
  Deprecated: 'deprecated',
} as const;

export type ProductInfoBadgeType =
  (typeof ProductInfoBadgeOptions)[keyof typeof ProductInfoBadgeOptions];

export type ProductInfoPropsMicrocopy = {
  reviewStars?: ReviewStarsPropsMicrocopy;
  badges: {
    [key in ProductInfoBadgeType]: key extends 'verifiedSolutions'
      ? {
          text: string;
          tooltip: {
            title: string;
            benefit1: string;
            benefit2: string;
            benefit3: string;
            cta: string;
          };
        }
      : {
          text: string;
          tooltip?: string;
        };
  };
  addToMyAssetSinglePackage: string;
  addToMyAssetMultiPackages: string;
  buyNow: string;
  openInUnity: string;
  seeOwnedPackages: string;
  addSeats: string;
  seats: string;
  quantitySelector: QuantitySelectorPropsMicrocopy;
  free: string;
  certifiedPublisher: CertifiedPublisherPropsMicrocopy;
  verifiedOrganization: string;
  verifiedIndividual: string;
  standardEulaMessage: string;
  customEulaMessage: string;
  refundPolicy: string;
  addToFavorites: string;
  removeFromFavorites: string;
  sale: {
    endsIn: string;
    newRelease: string;
    countdownWithDays: string;
    countdownHoursOnly: string;
  };
};

export type ProductInfoPropsPriceData = {
  currentPrice: number;
  originalPrice: number;
  currency?: string;
  discountPercent?: number;
};

export type ProductInfoPropsSaleData = {
  type: 'new_release_discount';
  dates: {
    starts: Date;
    ends: Date;
  };
};

export type ProductInfoPropsData = {
  type: 'single-package' | 'multi-package';
  nbOfPackages: number;
  isEntitled: boolean;
  badges: ProductInfoBadgeType[];
  publisherName: string;
  publisherLink: string;
  isCertifiedPublisher: boolean;
  publisherAccountType?: 'organization' | 'individual';
  publisherAvatarUrl?: string;
  productTitle: string;
  price: ProductInfoPropsPriceData;
  sale?: ProductInfoPropsSaleData;
  customEula?: string;
  reviews?: ReviewStarsPropsData;
  isFavorite?: boolean | null;
  isReviewsEnabled?: boolean;
  isPurchasing?: boolean;
};

export type ProductInfoPropsDataWithMicrocopy = ProductInfoPropsData & {
  microcopy: ProductInfoPropsMicrocopy;
};

export type ProductInfoPropsActions = {
  onProductCta?: (quantity: number) => void;
  onFavorite?: () => void;
  onAddSeats: () => void;
};

export type ProductInfoProps = ProductInfoPropsDataWithMicrocopy &
  ProductInfoPropsActions & {
    variant?: 'default' | 'sticky';
    className?: string;
  };
